import axios from "axios";
import { getToken } from "../../Utlis/UpdateUserState";

const getAuditLogs = async (startDate, endDate) => {
  try {
    const token = getToken();

    const params = new URLSearchParams();
    if (startDate) params.append("start_date", startDate);
    if (endDate) params.append("end_date", endDate);

    const query = params.toString();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fuel-vendor/audit-trail/${query ? `?${query}` : ""}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Audit logs fetch error:", error);
    throw error;
  }
};

export { getAuditLogs };
